<mat-card style="height:100%;overflow-y: auto;">
    <div class="table-responsive mt-3 p-3">
      <mat-table [dataSource]="trips" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell mat-header-cell *matHeaderCellDef style="text-align: center;">ID</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element; let i = index">{{ i+1 }}</mat-cell>
        </ng-container>
        <!-- Trip Name Column -->
        <ng-container matColumnDef="tripName">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">Trip Name</mat-header-cell>
          <mat-cell *matCellDef="let element" style="text-align: center;" style="text-align: center;">{{
            element.trip_name }}</mat-cell>
        </ng-container>

        <!-- Organization Column -->
        <ng-container matColumnDef="organization">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">Organization</mat-header-cell>
          <mat-cell *matCellDef="let element" style="text-align: center;">{{ element.org_id.name }}</mat-cell>
        </ng-container>

        <!-- User Column -->
        <ng-container matColumnDef="user">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">User</mat-header-cell>
          <mat-cell *matCellDef="let element" style="text-align: center;">{{ element.created_by.name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="tripStart">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">Trip Start</mat-header-cell>
          <mat-cell *matCellDef="let element" style="text-align: center;">{{ element.trip_start | date: 'dd-MM-yyyy'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="tripEnd">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">Trip End</mat-header-cell>
          <mat-cell *matCellDef="let element" style="text-align: center;">{{ element.trip_end | date: 'dd-MM-yyyy'}}</mat-cell>
        </ng-container>
        <!-- Trip Duration Column -->
        <ng-container matColumnDef="tripDuration">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">Trip Duration</mat-header-cell>
          <mat-cell *matCellDef="let element" [ngStyle]="{'text-align': element.trip_end && element.trip_start ? 'center' : 'left'}">
            {{
              element.trip_end && element.trip_start ? calculateTripDuration(element.trip_start, element.trip_end) + ' days' : 'End date not available'
            }}
          </mat-cell>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef style="text-align: left;">Description</mat-header-cell>
          <mat-cell *matCellDef="let element" [ngStyle]="{'text-align': element.description ? 'left' : 'left'}" style="text-align: left;">{{ element.description || 'Description not available' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="unarchive">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">Unarchive</mat-header-cell>
          <mat-cell *matCellDef="let element" style="text-align: center;">
              <mat-icon style="cursor: pointer; color: rgb(81, 82, 3); margin-right: 8px;"
              (click)="unArchive($event,element._id,element._etag)">unarchive</mat-icon>
          </mat-cell>
        </ng-container>
        <!-- Column definitions -->
        <mat-header-row *matHeaderRowDef="displayedColumns" style="text-align: center;"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" style="text-align: center;"></mat-row>
      </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5"></mat-paginator>
</mat-card>


